import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { SolutionSection } from '../components/SolutionSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProcessSection } from '../components/ProcessSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-[#0a0a0f] text-[#f0f0f0] font-inter selection:bg-[#00d4ff]/30" data-id="element-180">
      <HeroSection data-id="element-181" />
      <StorySection data-id="element-182" />
      <SolutionSection data-id="element-183" />
      <AudienceSection data-id="element-184" />
      <ProcessSection data-id="element-185" />
      <FAQSection data-id="element-186" />
      <OfferSection data-id="element-187" />
      <Footer data-id="element-188" />
    </main>;
}